import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function LocationHeritage() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="location"
      data-testid="location-section"
      ref={ref}
      className="py-24 md:py-32 lg:py-40 bg-[#FAF7F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}
            className="md:col-span-7"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="img-reveal">
                <img src="/images/renders/render4.jpg" alt="FINORA Havuz Alanı" className="w-full h-[260px] md:h-[350px] object-cover" />
              </div>
              <div className="img-reveal mt-8">
                <img src="/images/renders/render5.jpg" alt="FINORA Sahil" className="w-full h-[260px] md:h-[350px] object-cover" />
              </div>
            </div>
          </motion.div>

          <div className="md:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="flex items-center gap-4 mb-8">
                <div className="w-8 h-[2px] bg-[#c13a05]" />
                <span className="font-sub text-[#c13a05] text-[11px] tracking-[0.25em] font-bold">
                  KONUM & MİRAS
                </span>
              </div>

              <h2 className="font-heading text-4xl sm:text-5xl font-normal text-[#1A1A1A] tracking-tight leading-tight mb-8">
                Katmanlı Bir<br />
                <span className="italic text-[#9ac2cc]">Akdeniz Mirası</span>
              </h2>

              <p className="font-body text-[#5A5A58] text-base leading-relaxed font-light mb-5">
                Finike, yüzyıllardır değişmeyen bir dengeyle; denizi, toprağı ve zamanı bir arada tutan özel bir bölgedir.
              </p>

              <p className="font-body text-[#5A5A58] text-base leading-relaxed font-light mb-8">
                Limanıyla şekillenmiş, toprağıyla zenginleşmiş, tarihiyle derinleşmiş bir yaşam coğrafyasıdır.
                Likya'dan Roma'ya, Bizans'tan bugüne uzanan katmanlı bir kültürel miras...
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="space-y-5"
            >
              {[
                { title: "Likya Uygarlığı", desc: "Kaya mezarları ve antik semboller", color: "#c13a05" },
                { title: "Fenike Limanı", desc: "Binlerce yıllık ticaret tarihi", color: "#d5bd9a" },
                { title: "Akdeniz İklimi", desc: "365 gün güneş ve bereket", color: "#7d7441" },
                { title: "Denize Sıfır", desc: "Eşsiz sahil konumu", color: "#9ac2cc" },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4 group">
                  <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300" style={{ backgroundColor: item.color }} />
                  <div>
                    <p className="font-heading text-lg text-[#1A1A1A]">{item.title}</p>
                    <p className="font-body text-sm text-[#5A5A58] font-light">{item.desc}</p>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
